import { motion } from "framer-motion";
import {
  DocumentTextIcon,
  ArrowTopRightOnSquareIcon,
} from "@heroicons/react/24/solid";
import SidebarGalleryPage from "../Main/Sidebargallery";
import college from "../../assets/Home/college.jpg";

// Import your local PDF files
import tcPdf from "../../assets/Dowloads/TC Form.pdf";
import noDues from "../../assets/Dowloads/no dues.pdf";
import duplicateDiplomaPdf from "../../assets/Dowloads/diploma certificate.pdf";

const studentZoneInfo = {
  intro:
    "The Student Zone is dedicated to providing resources, support, and guidance to help students excel in their academic and personal journeys. Access a variety of materials, workshops, and more to aid in your development.",
  pdfLinks: [
    // Local PDF files (with direct asset imports)
    {
      title: "TC Form",
      file: tcPdf,
      isLocal: true,
    },
    {
      title: "NO Dues Form",
      file: noDues,
      isLocal: true,
    },
    {
      title: "Diploma Certificate",
      file: duplicateDiplomaPdf,
      isLocal: true,
    },
    // External URL PDFs
    {
      title: "Name Correction",
      url: "https://www.gwpcs.org/admin/images/downloads/name_correction.pdf",
      isLocal: false,
    },
    {
      title: "Provisioal Diploma Certificate",
      url: "https://www.gwpcs.org/admin/images/downloads/ProvisioalDiplomaCertificate.pdf",
      isLocal: false,
    },
    {
      title: "Revaluation Retotal",
      url: "https://www.gwpcs.org/admin/images/downloads/RevaluationRetotal.pdf",
      isLocal: false,
    },
    {
      title: "Urgent Diploma",
      url: "https://www.gwpcs.org/admin/images/downloads/urgentnew.pdf",
      isLocal: false,
    },
  ],
};

export default function StudentZone() {
  // Function to handle PDF view in new tab
  const handleViewPdf = (fileSource) => {
    window.open(fileSource, "_blank");
  };

  return (
    <div className="min-h-screen bg-gray-100 p-12">
      <div className="flex flex-col lg:flex-row gap-10">
        {/* Main Content */}
        <motion.div
          className="lg:col-span-2 flex-1"
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.5 }}
        >
          {/* Banner Image */}
          <div className="mb-7">
            <img
              src={college}
              alt="Student Zone Banner"
              className="w-full h-auto border-4 border-[#00BFA5] rounded-lg p-2 mb-10"
            />
          </div>

          <div className="border-4 border-[#00BFA5] p-2 rounded-lg mb-10">
            <h2 className="text-xl font-bold text-white bg-[#00BFA5] p-2 rounded-sm">
              Student Zone
            </h2>
            <p className="p-2">{studentZoneInfo.intro}</p>
          </div>

          {/* PDF Links */}
          <div className="space-y-6">
            {studentZoneInfo.pdfLinks.map((pdf, index) => {
              const fileSource = pdf.isLocal ? pdf.file : pdf.url;

              return (
                <div key={index} className="bg-white rounded-md shadow-md">
                  <div className="flex justify-between items-center bg-[#00BFA5] text-white font-semibold py-3 px-4 rounded-t-md">
                    <span>{pdf.title}</span>
                    <button
                      onClick={() => handleViewPdf(fileSource)}
                      className="flex items-center bg-white text-[#00BFA5] py-2 px-4 rounded-md hover:bg-gray-100 transition-colors duration-300"
                    >
                      {pdf.isLocal ? (
                        <>
                          <ArrowTopRightOnSquareIcon className="w-5 h-5 mr-2" />
                          View
                        </>
                      ) : (
                        <>
                          <ArrowTopRightOnSquareIcon className="w-5 h-5 mr-2" />
                          View
                        </>
                      )}
                    </button>
                  </div>

                  {/* PDF Thumbnail */}
                  {/* <div
                    className="p-4 cursor-pointer flex items-center justify-center border-b border-l border-r border-gray-300 rounded-b-md"
                    onClick={() => handleViewPdf(fileSource)}
                  >
                    <div className="flex flex-col items-center bg-gray-50 p-4 rounded-md hover:bg-gray-100 transition-colors duration-300 w-full">
                      <DocumentTextIcon className="w-16 h-16 text-[#00BFA5] mb-2" />
                      <p className="text-sm text-gray-600">
                        Click to view {pdf.title}
                      </p>
                    </div>
                  </div> */}
                </div>
              );
            })}
          </div>
        </motion.div>

        {/* Sidebar - Gallery */}
        <SidebarGalleryPage />
      </div>
    </div>
  );
}
